import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wc-desktop-ot-switcher"
}
const _hoisted_2 = { class: "container-xl wc-desktop-ot-switcher__inner" }
const _hoisted_3 = { class: "wc-desktop-ot-switcher__label" }
const _hoisted_4 = ["aria-current", "disabled", "onClick"]

import { ref } from 'vue';
import useOrderTypes from '@/composables/useOrderTypes';
import type OrderType from '@/models/entities/cart/order-type';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCDesktopOTSwitcher',
  setup(__props) {

const { visibleOrderTypes, currentOrderType, navigateToOrderTypeHome } = useOrderTypes();
const switching = ref(false);
const selectOrderType = async (ot: OrderType): Promise<void> => {
  switching.value = true;
  try {
    await navigateToOrderTypeHome(ot.id);
  } finally {
    switching.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(visibleOrderTypes) && _unref(visibleOrderTypes).length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('shoppingAs')), 1),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleOrderTypes), (ot) => {
            return (_openBlock(), _createElementBlock("button", {
              key: ot.id,
              class: _normalizeClass(["wc-desktop-ot-switcher__btn", { 'is-active': _unref(currentOrderType)?.id === ot.id }]),
              type: "button",
              "aria-current": _unref(currentOrderType)?.id === ot.id ? 'true' : undefined,
              disabled: switching.value,
              onClick: ($event: any) => (selectOrderType(ot))
            }, _toDisplayString(ot.name), 11, _hoisted_4))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})